/**
 * Утилита для правильного склонения слов в русском языке
 */

/**
 * Склонение слова "пара/пары/пар"
 * @param {number} count - количество
 * @returns {string} - "1 пара", "2 пары", "5 пар" и т.д.
 */
export function pluralizePairs(count) {
  const value = Number(count) || 0
  const n = Math.abs(value) % 100
  const n1 = n % 10
  if (n > 10 && n < 20) return `${value} пар`
  if (n1 > 1 && n1 < 5) return `${value} пары`
  if (n1 === 1) return `${value} пара`
  return `${value} пар`
}

/**
 * Склонение слова "товар/товара/товаров"
 * @param {number} count - количество
 * @returns {string} - "1 товар", "2 товара", "5 товаров" и т.д.
 */
export function pluralizeProducts(count) {
  const value = Number(count) || 0
  const n = Math.abs(value) % 100
  const n1 = n % 10
  if (n > 10 && n < 20) return `${value} товаров`
  if (n1 > 1 && n1 < 5) return `${value} товара`
  if (n1 === 1) return `${value} товар`
  return `${value} товаров`
}

/**
 * Универсальная функция склонения
 * @param {number} count - количество
 * @param {Object} forms - формы слова {one: "товар", few: "товара", many: "товаров"}
 * @returns {string}
 */
export function pluralize(count, forms) {
  const value = Number(count) || 0
  const n = Math.abs(value) % 100
  const n1 = n % 10
  if (n > 10 && n < 20) return `${value} ${forms.many}`
  if (n1 > 1 && n1 < 5) return `${value} ${forms.few}`
  if (n1 === 1) return `${value} ${forms.one}`
  return `${value} ${forms.many}`
}

/**
 * Универсальная функция склонения (только слово, без числа)
 * @param {number} count - количество
 * @param {Object} forms - формы слова {one: "селлер", few: "селлера", many: "селлеров"}
 * @returns {string}
 */
export function pluralizeWord(count, forms) {
  const value = Number(count) || 0
  const n = Math.abs(value) % 100
  const n1 = n % 10
  if (n > 10 && n < 20) return forms.many
  if (n1 > 1 && n1 < 5) return forms.few
  if (n1 === 1) return forms.one
  return forms.many
}
